/* cp-drop.js - Monthly Drop SR (15-21.10.2026): besplatna kutija uzoraka uz SVAKU porudzbinu.
   Mirko 14.10 po Ivanu (thread serbia-analysis): ista mehanika kao +1 (cp-plus1.js) -
   kutija se sama doda kad u korpi ima bilo sta placeno, na stavci je izbor Muska/Zenska/Unisex
   (fioka i /cart), najvise 1 po porudzbini, vraca se i posle rucnog izbacivanja.
   Poklon = proizvod poklon-kutija-uzoraka (1 din, SKU-PLUS1-KUTIJA-*), -1 din skida funkcija plus1-1din
   (prepoznaje sve SKU-PLUS1*). Kvalifikuju parfemi, paket 3 za 5250, bundlovi i kutije uzoraka (Maja 14.10, kao +1);
   pojedinacni uzorci, body mist, pojacivac i slicno sami ne donose kutiju. */
(function () {
  /* datumska kapija: 15.10 00:01 - 21.10 23:59:59 (Beograd); pre/posle radi samo uz ?cp_drop_preview=1 */
  var CP_POCETAK = 1791995780000; /* Ivan 14.10 18:36: 'aktiviraj odmah' (pre: 19:00 Petar) */
  var CP_KRAJ = 1792619999000;
  var cpPreview = /[?&]cp_drop_preview=1/.test(location.search);
  try {
    if (cpPreview) sessionStorage.setItem('cpDropPrev', '1');
    if (sessionStorage.getItem('cpDropPrev') === '1') cpPreview = true;
  } catch (e) {}
  if (!cpPreview && (Date.now() < CP_POCETAK || Date.now() > CP_KRAJ)) return;

  var VAR = { m: 67731758547053, z: 67731758579821, u: 67731758612589 };
  var IMENA = { 67731758547053: 'Muška', 67731758579821: 'Ženska', 67731758612589: 'Unisex' };
  var GRATIS_HANDLE = 'poklon-kutija-uzoraka';
  var PODRAZUMEVANI = VAR.u;
  /* 14.10: lista iz cp-plus1 (17.9) + 9 parfema dodatih posle toga u svi-parfemi */
  var PARFEMI = 'aventure-women,dragon-heart,error-chez-pierre-kolekcija,freedom,freedom-of-life,gotik-elixir,lemon-haze-woman,only-love-inspriisan-because-it-s-you-armani,sandy-beach,50-shades-of-vanilla,a-source-of-beauty,acrobal,african-day,amber-night,american-dream,aqua-profondo,aqua-profondo-inspirisan-acqua-di-gio-profondo-armani,aqua-source,aquaman,arabian-night,astral-beauty-inspirisan-andromeda-tiziana-terenzi,astral-beuty,athens,auroras,auroras-inspirisan-ganymede-marc-antoine-barrois,aventure,avenue-330,bakar,bandit,barbara,been-good-before,bel-homme,bel-homme-inspirisan-le-beau-jean-paul-gaultier,better-half,better-half-copy,bitter-life,black-diamond-1,blackest-black,blank,bliss-oud,bliss-oud-inspirisan-oud-for-happiness-initio-parfums-prives,bloody-moon,blue-chance,business-black,business-black-inspirisan-black-xs-paco-rabbane,campfire,cedar-pulse,cedar-pulse-inspirisan-cedrat-boise-mancera,chance-of-love,cinnamon-tea,citrus-drift-22,citrus-drift-22-inspirisan-bergamote-22-le-labo,citrus-wave,coconut-dream,coffee-dream,cosmic-glow,cosmic-glow-inspirisan-meteore-louis-vuitton,crush-effect,crush-effect-inspirisan-instant-crush-mancera,crystal-musk,cupcake,dark-dance,dark-fiction,dark-ritual,dark-ritual-chez-pierre-kolekcija,daylight,daylight-women,daylight-women-inspirisan-dylan-blue-versace,desert-tonka,desert-tonka-inspirisan-arabians-tonka-montale,diamond-oud,drama-queen,enigma,enthusiast,error,existation,extreme-life,falling-stars,feels-like-summer,fiction,first-and-last,flawless,flower-dream,flying-eagle,flying-eagle-inspirisan-althair-parfums-de-marly,fresh-day,fresh-day-inspirisan-aqva-bvlgari,full-moon,full-moon-inspirisan-moonlight-in-heaven-kilian,girl-power,golden-hour,golden-ray,good-sound,gotik,gotik-elixir-inspirisan-le-male-elixir-jean-paul-gaultier,hero,hint-of-vanilla,ibiza-colada,ibiza-colada-chez-pierre-kolekcija,immortal,imperialism,in-space,in-space-extreme,in-space-extreme-inspirisan-spicebomb-extreme-viktor-rolf,inconsistent,indian-spirit,irishman-power,jade-love,killer-phantom,lattea,lattea-inspirisan-bianco-late-giardini-di-toscana,leathery-path,lemon-haze-man,lemon-haze-woman-inspirisan-light-blue-d-g,live-extreme,lovely-paris,luxurious-1,madam-cherry,madam-feather,magnificent,magnificent-black,majestic-oud,majestic-oud-inspirisan-oud-for-greatness-initio-parfums-prives,million-dreams,mind-games,miracle-of-the-night,mirror,modern-love,money-money,moon-eclipse,my-inspiration,my-life,my-majesty,mystery-queen,new-world,ninth-star,nude-pudere,ocealis,ocealis-inspirisan-megamare-orto-parisi,ocean-breeze,ocean-breeze-inspirisan-pacific-chill-louis-vuitton,old-tree,only-love,oudly-satisfied,passion-vanilla,passion-vanilla-inspirisan-vanille-fatale-tom-ford,perfect-touch,pharaoh-ii,pleasure,private-beach,private-mission,private-mission-inspirisan-percival-parfums-de-marly,pure-ecstasy,pure-ecstasy-inspirisan-straight-to-heaven-kilian,purple-morning,question,roman-empire,roman-empire-inspirisan-roma-laura-biagiotti,rosewood,rosewood-inspirisan-rose-31-le-labo,sahara,salty-wood,sandy-coast,sandy-coast-inspirisan-on-the-beach-louis-vuitton,satisfaction,sealover,secret-garden,seraphia,silent-muse,silent-muse-chez-pierre-kolekcija,silent-note,silent-note-inspirisan-not-a-perfume-juliette-has-a-gun,silk-seduction,simona,skyfall,skylume,smoke-screen,smooth-jazz,soft-pink,spiced-bergamot,spring-flower,summer-night,super-man,sweet-tobacco,talisman,the-edge,the-edge-chez-pierre-kolekcija,the-great-king,the-sign-of-love,timmy,tobacco-shop,tornado,traveller,traveller-inspirisan-explorer-montblanc,tuxedo,ultimate-fire,un-uomo-italiano,un-uomo-italiano-inspirisan-born-in-roma-uomo-valentino,unforgettable,unwanted,unwanted-inspirisan-side-effect-initio-parfums-prives,vanilla-and-amber,vanillaholic,veneta,veneta-absolute,vermos,vermos-women,vermos-women-inspirisan-eros-versace,very-important-man,very-important-women,very-important-women-inspirisan-vip-212-carolina-herrera,victory,warrior,white-horse,white-horse-inspirisan-pegasus-parfums-de-marly,wild-bergamot,women-beauty,women-of-millionaire,wood-royal,wood-royal-inspirisan-bois-imperial-essential-parfums,you-and-me,you-and-me-intense,your-majesty'.split(',');
  var radim = false;
  /* 18.9 (Petrov nalaz): dok traje gratis operacija, checkout se zakljucava -
     inace klik na "Nastavi dalje" u sred zamene odvede na checkout bez gratisa */
  function cpZakljucaj(on) {
    document.querySelectorAll('#CartDrawer-Checkout,[name="checkout"]').forEach(function (b) {
      b.disabled = on;
      if (on) { b.setAttribute('aria-busy', 'true'); } else { b.removeAttribute('aria-busy'); }
    });
  }

  /* 14.10 Maja: kao dosadasnje akcije - kutija samo uz porudzbinu sa parfemom ili kutijom uzoraka (lista i pravila iz cp-plus1.js) */
  function kvalifikuje(item) {
    if (item.handle === GRATIS_HANDLE) return false;
    if (item.properties && item.properties._bundle_type === '10for2450') return true; /* 21.9 Petar: kutija sklopljena od 10 pojedinacnih uzoraka */
    if (PARFEMI.indexOf(item.handle) !== -1) return true;
    if (item.handle === '3-za-5250') return true;
    if (item.handle === '100-najpopularnijih-uzoraka') return true; /* 18.9 Petar: kutija 100 uzoraka kvalifikuje */
    if (item.handle === '10-parfemskih-uzoraka') return true;
    if (['fiction-bundle','hint-of-vanilla-bundle','secret-garden-bundle','athens-bundle','private-beach-bundle','vanillaholic-bundle','muski-bestseller-bundle','zenski-bestseller-bundle'].indexOf(item.handle) !== -1) return true; /* 18.9: bundlovi sadrze parfem */ /* 18.9: placena kutija 10x5ml se zove "Izaberite svoje uzorke" pa je naziv-pravilo ne hvata */
    var t = (item.product_title || '').toLowerCase();
    if (t.indexOf('kutija uzoraka') !== -1 && item.final_price > 100) return true;
    return false;
  }
  function jeGratis(item) { return item.handle === GRATIS_HANDLE; }

  function osveziPrikaz() {
    if (document.getElementById('CartDrawer')) {
      fetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
        if (s['cart-drawer']) {
          var doc = new DOMParser().parseFromString(s['cart-drawer'], 'text/html');
          var novi = doc.getElementById('CartDrawer');
          var stari = document.getElementById('CartDrawer');
          if (novi && stari) stari.innerHTML = novi.innerHTML;
        }
        var b = document.getElementById('cart-icon-bubble');
        if (b && s['cart-icon-bubble']) b.innerHTML = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').body.innerHTML;
        setTimeout(doteraj, 150);
      }).catch(function () {});
    }
    if (location.pathname.replace(/\/$/, '') === '/cart') { location.reload(); }
  }

  /* 18.9: farbanje iz ODGOVORA istog cart poziva (sections u body-ju) - jedan konzistentan
     snimak fioke, bez trke sa Dawn-ovim sopstvenim renderom (Petar: prazna fioka posle brisanja) */
  function ofarbaj(data) {
    if (!data || !data.sections) { osveziPrikaz(); return; }
    if (data.sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
      var novi = doc.getElementById('CartDrawer');
      var stari = document.getElementById('CartDrawer');
      if (novi && stari) stari.innerHTML = novi.innerHTML;
      var cd = document.querySelector('cart-drawer');
      if (cd) { if (data.item_count === 0) { cd.classList.add('is-empty'); } else { cd.classList.remove('is-empty'); } }
    }
    var b = document.getElementById('cart-icon-bubble');
    if (b && data.sections['cart-icon-bubble']) b.innerHTML = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html').body.innerHTML;
    setTimeout(doteraj, 150);
    if (location.pathname.replace(/\/$/, '') === '/cart') { location.reload(); }
  }

  var proslo = { gratis: false, kval: false };
  function sprovedi() {
    if (radim) return;
    radim = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var gratis = null, kval = false;
      cart.items.forEach(function (i) {
        if (jeGratis(i)) gratis = i;
        else if (kvalifikuje(i)) kval = true;
      });
      /* 18.9 Petar: gratis se UVEK vraca kad korpa kvalifikuje (i posle rucnog izbacivanja);
         jedino pravilo je najvise 1 gratis po porudzbini (cap ispod) */
      proslo = { gratis: !!gratis, kval: kval };
      try { sessionStorage.removeItem('cpDropNe'); } catch (e) {}

      if (kval && !gratis) {
        cpZakljucaj(true);
        return fetch('/cart/add.js?cpDrop=1', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: PODRAZUMEVANI, quantity: 1, sections: 'cart-drawer,cart-icon-bubble' }) })
          .then(function (r) { return r.json(); })
          .then(function (data) { proslo = { gratis: true, kval: true }; radim = false; ofarbaj(data); cpZakljucaj(false); });
      }
      if (gratis && !kval) {
        cpZakljucaj(true);
        return fetch('/cart/change.js?cpDrop=1', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: gratis.key, quantity: 0, sections: 'cart-drawer,cart-icon-bubble' }) })
          .then(function (r) { return r.json(); })
          .then(function (data) { proslo = { gratis: false, kval: false }; radim = false; ofarbaj(data); cpZakljucaj(false); });
      }
      if (gratis && gratis.quantity > 1) {
        cpZakljucaj(true);
        return fetch('/cart/change.js?cpDrop=1', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: gratis.key, quantity: 1, sections: 'cart-drawer,cart-icon-bubble' }) })
          .then(function (r) { return r.json(); })
          .then(function (data) { radim = false; ofarbaj(data); cpZakljucaj(false); });
      }
      radim = false;
      doteraj(gratis);
    }).catch(function () { radim = false; cpZakljucaj(false); });
  }
  window.cpDropEnforce = sprovedi;

  function doteraj(gratisItem) {
    var linkovi = document.querySelectorAll('a[href*="' + GRATIS_HANDLE + '"]');
    linkovi.forEach(function (a) {
      var red = a.closest('.cart-item') || a.closest('tr') || a.closest('[id^="CartDrawer-Item"], [id^="CartItem"]');
      if (!red || red.querySelector('.cp-drop-blok')) return;
      // sakrij kontrole kolicine za gratis red
      red.querySelectorAll('quantity-input, .cart-item__quantity-wrapper, .quantity').forEach(function (q) { q.style.display = 'none'; });
      var sel = document.createElement('select');
      sel.className = 'cp-drop-select';
      sel.setAttribute('aria-label', 'Vrsta poklon kutije uzoraka');
      Object.keys(VAR).forEach(function (k) {
        var o = document.createElement('option');
        o.value = VAR[k]; o.textContent = IMENA[VAR[k]] + ' kutija';
        sel.appendChild(o);
      });
      var trenutna = null;
      var tekst = red.textContent;
      Object.keys(IMENA).forEach(function (vid) { if (tekst.indexOf(IMENA[vid]) !== -1) trenutna = vid; });
      if (trenutna) sel.value = trenutna;
      sel.addEventListener('change', function () {
        var novi = Number(sel.value);
        sel.disabled = true;
        radim = true;
        cpZakljucaj(true);
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var g = cart.items.filter(jeGratis)[0];
          if (!g) return;
          /* atomska zamena: jedan update.js poziv - korpa ni u jednom trenutku nije bez gratisa */
          var updates = {};
          updates[g.variant_id] = 0;
          updates[novi] = 1;
          return fetch('/cart/update.js?cpDrop=1', { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates, sections: 'cart-drawer,cart-icon-bubble' }) });
        }).then(function (r) { return r ? r.json() : null; })
          .then(function (data) { radim = false; proslo = { gratis: true, kval: true }; ofarbaj(data); cpZakljucaj(false); })
          .catch(function () { radim = false; sel.disabled = false; cpZakljucaj(false); });
      });
      var blok = document.createElement('div');
      blok.className = 'cp-drop-blok';
      var lab = document.createElement('div');
      lab.className = 'cp-drop-lab';
      lab.textContent = '👇 Izaberi svoju kutiju:';
      blok.appendChild(lab);
      blok.appendChild(sel);
      var ime = red.querySelector('.cart-item__name') || a;
      ime.parentNode.insertBefore(blok, ime.nextSibling);
      var stil = document.createElement('style');
      stil.textContent = '.cp-drop-blok{display:block;margin:.6rem 0 .2rem;padding:.6rem .7rem;background:#FFEDE2;border:.15rem solid #AD421A;border-radius:.8rem;max-width:22rem}' +
        '.cp-drop-lab{font-size:1.15rem;font-weight:700;color:#3a3a3a;margin-bottom:.4rem;line-height:1.25}' +
        '.cp-drop-select{display:block;width:100%;font-size:1.4rem;font-weight:600;padding:.55rem .7rem;border:.15rem solid #AD421A;border-radius:.6rem;background:#fff;color:#AD421A;cursor:pointer}' +
        '.cart-item:has(a[href*="poklon-kutija-uzoraka"]) quantity-input,' +
        '.cart-item:has(a[href*="poklon-kutija-uzoraka"]) .quantity,' +
        '.cart-item:has(a[href*="poklon-kutija-uzoraka"]) .cart-item__quantity-wrapper quantity-input,' +
        'tr:has(a[href*="poklon-kutija-uzoraka"]) quantity-input,' +
        'tr:has(a[href*="poklon-kutija-uzoraka"]) .quantity,' +
        'tr:has(a[href*="poklon-kutija-uzoraka"]) .cp-qty,' +
        '.cart-item:has(a[href*="poklon-kutija-uzoraka"]) .cp-qty{display:none!important}';
      if (!document.getElementById('cp-drop-stil')) { stil.id = 'cp-drop-stil'; document.head.appendChild(stil); }
    });
  }

  // okidaci: svaka cart mutacija sa sajta + ucitavanje stranice
  var stariFetch = window.fetch;
  window.fetch = function () {
    var arg = arguments[0];
    var p = stariFetch.apply(this, arguments);
    try {
      var u = typeof arg === 'string' ? arg : (arg && arg.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(u) && u.indexOf('cpDrop') === -1) {
        p.then(function () { setTimeout(sprovedi, 150); });
      }
    } catch (e) {}
    return p;
  };
  function cpStart() { setTimeout(sprovedi, 350); setTimeout(sprovedi, 1600); setTimeout(sprovedi, 3500); }
  setInterval(function cpCuvar() { try { if (document.querySelector('a[href*="' + GRATIS_HANDLE + '"]') && !document.querySelector('.cp-drop-blok')) sprovedi(); } catch (e) {} }, 4000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cpStart);
  else cpStart();
})();

